import { useState, useEffect } from 'react';
import { Button, Col, Container, Form, OverlayTrigger, Row, Tooltip, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TabComponent from "../../../common/TabComponent";
import { apiService } from "../../../service/api.service";
import { baseUrl, errorHandling } from "../../../config/config";
import Loader from "../../../common/Loader";
import Pagination from "react-js-pagination";
import swal from 'sweetalert';
import moment from "moment";

const ProjectManagementView = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [catlist, setcatlist] = useState([]);
    const [allProducts, setAllProducts] = useState();
    const [totalItems, settotalItems] = useState();
    const [searchName, setsearchName] = useState(null);
    const [catId, setcatId] = useState(null);
    const [loader, setLoader] = useState(false);
    const [showStock, setShowStock] = useState(false);
    const [availableStock, setavailableStock] = useState();
    const [cultivatorId, setcultivatorId] = useState();
    const [availableStockErr, setavailableStockErr] = useState("");
    const handleCloseStock = () => setShowStock(false);
    const handleShowStock = () => setShowStock(true);
    const [profile_status, setprofile_status] = useState(localStorage.getItem("profile_status"));

    const redirect = (type) => {
        navigate(type);
    };

    useEffect(() => {
        getProducts(page, limit, catId, searchName);
        GetCategoryList();
    }, []);

    function handlePageChange(pageNumber) {
        setPage(pageNumber - 1);
        getProducts(pageNumber - 1, limit, catId, searchName);
    }

    async function GetCategoryList() {
        try {
            setLoader(true);
            const response = await apiService.GetCategoryList();
            console.log("category...", response);
            if (response?.status == 200) {
                setcatlist(response?.data?.data.list);
                setLoader(false);
            }
        } catch (err) {
            errorHandling(err.response.status);
            setLoader(false);
        }
    }

    const getProducts = (page, limit, cat, name) => {
        setLoader(true);
        apiService.getProducts(page, limit, cat, name).then((res) => {
            setLoader(false);
            console.log("res======", res);
            settotalItems(res.data.data.total);
            setAllProducts(res.data.data.list);
        }).catch((err) => {
            errorHandling(err.response.status);
            setLoader(false);
            console.log("contact us api error", err.response);
        });
    };

    const changeCatId = (id) => {
        if (id == "All") {
            id = null;
        }
        setcatId(id);
        setPage(0);
        getProducts(0, limit, id, searchName);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && searchName && searchName.trim() != "") {
            setPage(0);
            getProducts(0, limit, catId, searchName);
        }
    };

    const handlesearch = () => {
        if (searchName && searchName.trim() != "") {
            setPage(0);
            getProducts(0, limit, catId, searchName);
        }
    };

    const stockAvailableView = (id, qty) => {
        setavailableStock(qty);
        setcultivatorId(id);
        handleShowStock();
    };

    const addStock = () => {
        if (!availableStock) {
            setavailableStockErr("Please add stock value.");
            return false;
        }
        apiService.addStock(cultivatorId, availableStock).then((res) => {
            handleCloseStock();
            swal("Success", "Stock added successfully.", "success");
            getProducts(page, limit, catId, searchName);
            setLoader(false);
            console.log("======res====", res);
        }).catch((err) => {
            setLoader(false);
            console.log("contact us api error", err);
        });
    };

    const tooltip = (
        <Tooltip id="tooltip">
            Product Inventory
        </Tooltip>
    );
    const tooltip_view = (
        <Tooltip id="tooltip">
            View Detail
        </Tooltip>
    );
    const tooltip_edit = (
        <Tooltip id="tooltip">
            Edit Product
        </Tooltip>
    );
    const tooltip_per_package = (
        <Tooltip id="tooltip">
            Per Packaging
        </Tooltip>
    );

    const handleClick = () => {
        setsearchName(null);
        setPage(0);
        getProducts(0, limit, catId, null);
    };

    const handleKeyDownnumber = (event) => {
        console.log("=====event====", event.which);
        if (event.which === 32) {
            event.preventDefault();
        }
        if (event.which === 189) {
            event.preventDefault();
        }
        if (event.key === "Enter" || event.which === 13) {
            event.preventDefault();
        }
    };

    const startItem = allProducts && allProducts.length > 0 ? page * limit + 1 : 0;
    const endItem = allProducts && allProducts.length > 0 ? Math.min((page + 1) * limit, totalItems || allProducts.length) : 0;

    return (
        <>
            <div className="height-footer dashboard-page">
                {loader && <Loader />}
                <Container>
                    <div className="dashboard-shell">
                        <div className="dashboard-sidebar">
                            <TabComponent />
                        </div>
                        <div className="dashboard-main">
                            <div className="tab-pane" id="product-management">
                                <div className='product-management common-under-padding'>
                                    {/* Top Control Bar Header */}
                                    <div className='product-header-area status-bar'>
                                        <div className='under-heading w-100 d-flex align-items-center justify-content-between flex-wrap gap-3'>
                                            <div className="d-flex align-items-center gap-3 flex-wrap flex-grow-1">
                                                <div className='search-box position-relative'>
                                                    <img
                                                        className="search-img"
                                                        src={require("../../../assets/images/search.svg").default}
                                                        alt="img"
                                                        onClick={() => handlesearch()}
                                                    />
                                                    <Form.Control
                                                        type="input"
                                                        placeholder="Search by product name..."
                                                        value={searchName == null ? "" : searchName}
                                                        onChange={(e) => setsearchName(e.target.value)}
                                                        onKeyDown={handleKeyPress}
                                                    />
                                                    {searchName != null && <i className="fa fa-times" aria-hidden="true" onClick={handleClick}></i>}
                                                </div>
                                                <div className='select-box-mobile me-3'>
                                                    <Form.Select aria-label="Default select example" onChange={(e) => changeCatId(e.target.value)}>
                                                        <option value={"All"}>Select Category</option>
                                                        {catlist.map((cat, i) => (
                                                            <option key={i} value={cat.id} >
                                                                {cat.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </div>
                                            </div>
                                            <div>
                                                {profile_status == "Accept" ?
                                                    <>
                                                        {localStorage.getItem("stripeBankId") == "null" || localStorage.getItem("stripeBankId") == null ?
                                                            <Button className='green-btn not_added' onClick={() => {
                                                                swal({
                                                                    title: "Bank Not Added",
                                                                    text: `Bank details are required to proceed with adding a product. Please provide your bank details.`,
                                                                    icon: "warning",
                                                                    buttons: ["Cancel", "Add Bank"],
                                                                }).then((value) => {
                                                                    if (value) {
                                                                        redirect('/bank-details');
                                                                    } else {
                                                                        console.log("NO button clicked or popup closed");
                                                                    }
                                                                });
                                                            }}> + Add New Product </Button> :
                                                            <Button className='green-btn' onClick={() => { redirect('/product-mangement/add-product') }}> + Add New Product</Button>
                                                        }
                                                    </> :
                                                    <Button className='green-btn disabled' onClick={() => { redirect('/product-mangement/add-product') }}> + Add New Product</Button>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {/* Product Table Container Card */}
                                    <div className='table-data product-table-container-card'>
                                        <div className="table-responsive">
                                            <table className="table product-view-table">
                                                <thead>
                                                    <tr>
                                                        <th>#Product ID</th>
                                                        <th>Product Name</th>
                                                        <th>Category</th>
                                                        <th>Packaging</th>
                                                        <th>Unit</th>
                                                        <th className='price-text'>Price <OverlayTrigger placement="top" overlay={tooltip_per_package}><i className="fa-solid fa-circle-exclamation"></i></OverlayTrigger></th>
                                                        <th>Description</th>
                                                        <th>Created At</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {allProducts && allProducts.map((data, i) => {
                                                        const displayId = data.id ? (data.id.toString().startsWith("PRD") ? data.id : `PRD-${1000 + Number(data.id) || data.id}`) : `PRD-${1001 + i}`;
                                                        const displayPrice = data.price ? (data.price.toString().startsWith("$") ? data.price : `$${data.price}`) : "$0.00";
                                                        const isGrain = data.category && data.category.toLowerCase().includes("grain");

                                                        return (
                                                            <tr key={data.id || i}>
                                                                <td className="product-id-cell">{displayId}</td>
                                                                <td>
                                                                    <div className='product-outer-main'>
                                                                        <span className='product-img'>
                                                                            <img
                                                                                src={baseUrl + data.path}
                                                                                alt="img"
                                                                                onError={(e) => {
                                                                                    e.target.src = require("../../../assets/images/bell-pepper.png");
                                                                                }}
                                                                            />
                                                                        </span>
                                                                        <div className="product-title-group">
                                                                            <span className="product-title-bold">{data.name}</span>
                                                                            <span className="product-title-sub">
                                                                                {data.subTitle || data.subName || data.shortDescription || "Farm fresh and juicy"}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span className={`cat-pill ${isGrain ? "cat-pill-blue" : "cat-pill-green"}`}>
                                                                        {data.category || "Vegetables"}
                                                                    </span>
                                                                </td>
                                                                <td>{data.packaging || "—"}</td>
                                                                <td>{data.unit || "kg"}</td>
                                                                <td><span className="price-green-bold">{displayPrice}</span></td>
                                                                <td><p className='description-txt-truncated'>{data.description}</p></td>
                                                                <td>
                                                                    <div className="date-time-stack">
                                                                        <span className="date-bold">{moment(data?.createdDate).format("MMM DD, YYYY")}</span>
                                                                        <span className="time-muted">{moment(data?.createdDate).format("hh:mm A")}</span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='action-btn-row'>
                                                                        <OverlayTrigger placement="top" overlay={tooltip_view}>
                                                                            <Link 
                                                                                to={"/product-mangement/view-inventory/" + data.id + "/" + data.productCultivatorId}
                                                                                className="action-icon-box box-blue"
                                                                            >
                                                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                                                                    <circle cx="12" cy="12" r="3"></circle>
                                                                                </svg>
                                                                            </Link>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger placement="top" overlay={tooltip_edit}>
                                                                            <button 
                                                                                type="button" 
                                                                                className="action-icon-box box-green"
                                                                                onClick={() => redirect('/product-mangement/add-product')}
                                                                            >
                                                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                                                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                                                                </svg>
                                                                            </button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger placement="top" overlay={tooltip}>
                                                                            <button 
                                                                                type="button"
                                                                                className="action-icon-box box-red"
                                                                                onClick={() => stockAvailableView(data.productCultivatorId, data.quantity)}
                                                                            >
                                                                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                    <polyline points="3 6 5 6 21 6"></polyline>
                                                                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                                                </svg>
                                                                            </button>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>

                                        {allProducts && allProducts.length == 0 && (
                                            <div className="nodata centre p-4">
                                                <img src={require("../../../assets/images/no-data-found.png")} alt="img" />
                                                <span>No data Found</span>
                                            </div>
                                        )}

                                        {/* Table Footer */}
                                        {allProducts && allProducts.length > 0 && (
                                            <div className="product-table-card-footer">
                                                <div className="showing-info-txt">
                                                    Showing {startItem} to {endItem} of {totalItems || allProducts.length} products
                                                </div>
                                                {totalItems > limit && (
                                                    <div className='pagination-tab modern-pagination-tab'>
                                                        <Pagination
                                                            activePage={page + 1}
                                                            itemsCountPerPage={limit}
                                                            totalItemsCount={totalItems}
                                                            pageRangeDisplayed={5}
                                                            onChange={(e) => handlePageChange(e)}
                                                            prevPageText="<"
                                                            nextPageText=">"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            {/* Stock Modal */}
            <Modal
                show={showStock}
                onHide={handleCloseStock}
                className="modal-success quantity-box"
                backdrop="static"
                centered
            >
                <Modal.Header closeButton className="border-0">
                    <Modal.Title>Add Available Stock</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-success-body">
                        <Form className="login-body quantity-box-inner">
                            <Form.Group className="position-relative">
                                <div className="cart-input">
                                    <button 
                                        type='button' 
                                        className={availableStock == 0 ? "minus-btn disabled" : "minus-btn"} 
                                        onClick={() => {
                                            if (availableStock > 0) { setavailableStock(parseInt(availableStock) - 1); }
                                        }}
                                    >
                                        -
                                    </button>
                                    <Form.Control 
                                        className="quantity-input" 
                                        onKeyDown={handleKeyDownnumber} 
                                        maxLength={8}
                                        onWheel={() => document.activeElement.blur()}
                                        type="number"
                                        placeholder="Enter"
                                        value={availableStock}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            const sanitizedValue = inputValue.replace(/-/g, '');
                                            setavailableStock(sanitizedValue);
                                        }}
                                    />
                                    <button type='button' className="plus-btn" onClick={() => setavailableStock(parseInt(availableStock) + 1)}>+</button>
                                </div>

                                <span className="text-danger">
                                    {availableStockErr}
                                </span>
                            </Form.Group>
                            <div className='text-center'>
                                <Button type="button" className="green-btn" onClick={addStock}>
                                    Save
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProjectManagementView;